<template>
  <div />
</template>

<script>

/**
 * Vue: Boost analytics (boost-analytics)
 * -----------------------------------------------------------------------------
 * Sends events data to Boost for app analytics.
 * @param {Object} analyticsEvent
 * @param {String} type - Boost endpoint being used
 */

import { v4 as uuidv4 } from 'uuid'
import { mapState } from 'vuex'

export default {
  name: 'BoostAnalytics',

  props: {
    analyticsEvent: {
      type: Object,
      default: () => ({}),
    },

    type: {
      type: String,
      default: 'filter',
    },
  },

  data() {
    return {
      global: true,
      sessionId: JSON.parse(window.localStorage.getItem('boostPFSSessionId')) || false,
      shop: `${window.cnvs.credentials.storefront.store}.myshopify.com`,
      token: window.cnvs.credentials.storefront.token,
    }
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      choices: (state) => state.index.choices,
    }),
  },

  watch: {
    analyticsEvent(data) {
      this.queryAnalytics(data)
    },
  },

  mounted() {
    this.checkSessionId()
  },

  methods: {

    /**
     * Check for Boost session ID and set one if not set.
     * - Boost JS files usually set this under a conventional install
     * - A random string where the only requirement is that it's persistent.
     */
    checkSessionId() {
      if (this.sessionId) {
        return
      }

      localStorage.setItem('boostPFSSessionId', JSON.stringify(uuidv4()))
      this.sessionId = JSON.parse(window.localStorage.getItem('boostPFSSessionId'))
    },

    /**
     * Submit data to Boost Analytics.
     * - This isn't documented, but you can monitor what should be sent by
     *   viewing the Boost demo on their site and watching the Network tab.
     * @param {Object} data - Formatted data to send to Boost Analytics.
     * @param {String} type - 'filter' or 'search/suggest'.
     */
    // eslint-disable-next-line require-await
    async queryAnalytics(data = {}) {

      /**
       * a: Boost location: 'filter' or 'search'
       * ct: /cart.js token
       * tid: Shop URL
       * pid: product ID
       * t: UTC ISO 8601 timestamp.
       * u: Boost events: view_product, add_to_cart
       * qs: Boost query.
       * r: document.referrer
       * sid: Boost Session ID.
       */

      const defaultData = {
        a: this.type,
        ct: this.token,
        qs: this.choices,
        r: document.referrer,
        sid: this.sessionId,
        t: new Date().toISOString(),
        tid: this.shop,
      }

      const combined = {
        ...defaultData,
        ...data,
      }

      /**
       * Remove any falsey values.
       */
      for (const [key, value] of Object.entries(combined)) {
        if (!value) {
          delete combined[key]
        }
      }

      if (combined.u === 'add_to_cart') {
        delete combined.a
        delete combined.r
        delete combined.t
      }

      /**
       * Make query.
       */
      const headers = {
        'Content-Type': 'application/json',
      }

      const body = JSON.stringify(combined)

      fetch('https://lambda.mybcapps.com/e', {
        method: 'POST',
        headers,
        body,
      })
        .then((response) => {
          return response
        })
        .catch((error) => {
          throw new Error(error)
        })
    },
  },
}
</script>
